export const getAllFilterOptions = (data, selectedUserRole) => {
  const divisions = new Set();
  const zones = new Set();
  const regions = new Set();
  const hqs = new Set();
  const userIds = new Set(); 
  const flmManagerNames = new Set(); 

  data.filter_Data.forEach((division) => {
    if (division.divisionname && division.divisionname !== "") {
      divisions.add(division.divisionname);
    }
    division.zones.forEach((zone) => {
      if (zone.zonename && zone.zonename !== "") {
        zones.add(zone.zonename);
      }
      zone.regions.forEach((region) => {
        if (region.regionname && region.regionname !== "") {
          regions.add(region.regionname);
        }
        region.hQs.forEach((hq) => {
          if (hq.hqname && hq.hqname !== "") {
            hqs.add(hq.hqname);
          }
          hq.employees.forEach((employee) => {
            if (
              employee.user_role.toUpperCase() === "MR" &&
              employee.username &&
              employee.username !== ""
            ) {
              userIds.add(employee.username); 
            }

            if (
              employee.manager_role &&
              employee.manager_role.toUpperCase() === "FLM" &&
              employee.manager_name &&
              employee.manager_name !== ""
            ) {
              flmManagerNames.add(employee.manager_name);
            }
          });
        });
      });
    });
  });

  const hierarchyLevels = {
    SLM: ["SLM", "FLM", "MR"],
    FLM: ["FLM", "MR"],
    MR: ["MR"],
  };

  const userRole = data.user_Details.user_Role.toUpperCase();
  const availableRoles = hierarchyLevels[userRole] || ["MR"];


  let userIdOptions;
  if (userRole === "SLM") {
    if (selectedUserRole === "SLM") {
      userIdOptions =
        data.user_Details.userName && data.user_Details.userName !== ""
          ? [data.user_Details.userName]
          : [];
    } else if (selectedUserRole === "FLM") {
      userIdOptions =
        flmManagerNames.size > 0
          ? Array.from(flmManagerNames)
          : ["No FLM Managers Found"];
    } else if (selectedUserRole === "MR") {
      userIdOptions =
        userIds.size > 0 ? Array.from(userIds) : ["No MR Employees Found"];
    }
  } else if (userRole === "FLM" && selectedUserRole === "FLM") {
    userIdOptions =
      data.user_Details.userName && data.user_Details.userName !== ""
        ? [data.user_Details.userName]
        : [];
  } else {
    userIdOptions =
      userIds.size > 0 ? Array.from(userIds) : ["No Employees Found"];
  }

  return {
    division: Array.from(divisions),
    zone: Array.from(zones),
    region: Array.from(regions),
    hq: Array.from(hqs),
    user_role: availableRoles,
    user_id: userIdOptions,
    salesIn: ["Lacs", "Crores"], 
  };
};

export const getCodeMappings = (data) => {
  const divisionMap = {};
  const zoneMap = {};
  const regionMap = {};
  const hqMap = {};
  const userIdMap = {};
  const flmToReportsMap = {};

  data.filter_Data.forEach((division) => {
    divisionMap[division.divisionname] = division.divisioncode;
    division.zones.forEach((zone) => {
      zoneMap[zone.zonename] = zone.zonecode;
      zone.regions.forEach((region) => {
        regionMap[region.regionname] = region.regioncode;
        region.hQs.forEach((hq) => {
          hqMap[hq.hqname] = hq.hqcode;
          hq.employees.forEach((employee) => {
            if (employee.user_role.toUpperCase() === "MR") {
              userIdMap[employee.username] = employee.userid;
            }
            if (
              employee.manager_role &&
              employee.manager_role.toUpperCase() === "FLM" &&
              employee.manager_name
            ) {
              userIdMap[employee.manager_name] = employee.reporting_manager_id;
            }
            if (
              employee.manager_role?.toUpperCase() === "FLM" &&
              employee.reporting_manager_id
            ) {
              if (!flmToReportsMap[employee.reporting_manager_id]) {
                flmToReportsMap[employee.reporting_manager_id] = [];
              }
              if (employee.user_role.toUpperCase() === "MR") {
                flmToReportsMap[employee.reporting_manager_id].push(
                  employee.userid
                );
              }
            }
          });
        });
      });
    });
  });

  userIdMap[data.user_Details.userName] = data.user_Details.user_Id;

  return { divisionMap, zoneMap, regionMap, hqMap, userIdMap, flmToReportsMap };
};

export const getAllOptionsForSLM = (data) => {
  const divisions = new Set();
  const zones = new Set();
  const regions = new Set();
  const hqs = new Set();

  data.filter_Data.forEach((division) => {
    if (division.divisionname && division.divisionname !== "") {
      divisions.add(division.divisionname);
    }
    division.zones.forEach((zone) => {
      if (zone.zonename && zone.zonename !== "") {
        zones.add(zone.zonename);
      }
      zone.regions.forEach((region) => {
        if (region.regionname && region.regionname !== "") {
          regions.add(region.regionname);
        }
        region.hQs.forEach((hq) => {
          if (hq.hqname && hq.hqname !== "") {
            hqs.add(hq.hqname);
          }
        });
      });
    });
  });

  return {
    division: Array.from(divisions),
    zone: Array.from(zones),
    region: Array.from(regions),
    hq: Array.from(hqs),
  };
};
export const getRelatedSelections = (data, filter, values, selectedUserRole) => {
  const related = {
    division: new Set(),
    zone: new Set(),
    region: new Set(),
    hq: new Set(),
    user_id: new Set(),
  };

  const userRole = data.user_Details.user_Role.toUpperCase();
  const slmUserName = data.user_Details.userName;

  if (
    filter === "user_id" &&
    userRole === "SLM" &&
    values.includes(slmUserName)
  ) {
    const allOptions = getAllOptionsForSLM(data);
    return {
      division: allOptions.division,
      zone: allOptions.zone,
      region: allOptions.region,
      hq: allOptions.hq,
      user_id: values,
    };
  }

  const flmUserIds = new Set(); 
  const mrUserIds = new Set(); 

  data.filter_Data.forEach((division) => {
    division.zones.forEach((zone) => {
      zone.regions.forEach((region) => {
        region.hQs.forEach((hq) => {
          hq.employees.forEach((employee) => {
            const matchesFilter =
              (filter === "division" &&
                values.includes(division.divisionname)) ||
              (filter === "zone" && values.includes(zone.zonename)) ||
              (filter === "region" && values.includes(region.regionname)) ||
              (filter === "hq" && values.includes(hq.hqname)) ||
              (filter === "user_id" &&
                ((employee.user_role.toUpperCase() === "MR" &&
                  values.includes(employee.username)) ||
                  (employee.manager_role?.toUpperCase() === "FLM" &&
                    values.includes(employee.manager_name))));

            if (matchesFilter) {
              related.division.add(division.divisionname);
              related.zone.add(zone.zonename);
              related.region.add(region.regionname);
              related.hq.add(hq.hqname);

              if (selectedUserRole === "MR") {
               
                if (
                  employee.user_role.toUpperCase() === "MR" &&
                  employee.username
                ) {
                  mrUserIds.add(employee.username);
                }
              } else if (selectedUserRole === "FLM") {
             
                if (
                  employee.manager_role?.toUpperCase() === "FLM" &&
                  employee.manager_name
                ) {
                  flmUserIds.add(employee.manager_name);
                }
                if (
                  employee.user_role.toUpperCase() === "MR" &&
                  employee.username
                ) {
                  mrUserIds.add(employee.username);
                }
              }
            }
          });
        });
      });
    });
  });


  related.user_id =
    selectedUserRole === "MR" ? [...mrUserIds] : [...flmUserIds, ...mrUserIds];

  return {
    division: Array.from(related.division),
    zone: Array.from(related.zone),
    region: Array.from(related.region),
    hq: Array.from(related.hq),
    user_id: Array.from(related.user_id),
  };
};